export const SharePrompt = () => {
  return (
    <p className="text-lg font-semibold text-secondary animate-bounce mb-6">
      👇 Cliquez sur les liens ci-dessous pour partager directement, on compte sur vous ! 👇
    </p>
  );
};